/** Port der Settings-Feldgruppen aus legacy app.js (sv.*-Keys + Labels + Typ). */

export type SettingType = "text" | "textarea" | "num" | "toggle";
export interface SettingField {
  key: string;
  label: string;
  type: SettingType;
}
export interface SettingGroup {
  group: string;
  fields: SettingField[];
}

const f = (key: string, label: string, type: SettingType): SettingField => ({ key, label, type });

export const SETTINGS: SettingGroup[] = [
  { group: "Server", fields: [
    f("sv.serverName", "Server name", "text"),
    f("sv.welcomeMessage", "Welcome message (|| = line break)", "textarea"),
    f("sv.password", "Server password (empty = open)", "text"),
    f("sv.maxPlayers", "Max players", "num"),
    f("sv.allowSpectators", "Allow spectators", "toggle"),
    f("sv.allowFreeCam", "FreeCam", "toggle"),
    f("sv.allowExternalViews", "External view", "toggle"),
    f("sv.allowNoseCam", "NoseCam", "toggle"),
    f("sv.hitIndicator", "Hit indicator", "toggle"),
  ] },
  { group: "Round", fields: [
    f("sv.ticketRatio", "Ticket ratio (%)", "num"),
    f("sv.timeLimit", "Time limit (0 = off)", "num"),
    f("sv.scoreLimit", "Score limit (0 = off)", "num"),
    f("sv.roundsPerMap", "Rounds per map", "num"),
    f("sv.spawnTime", "Spawn time", "num"),
    f("sv.manDownTime", "ManDown time", "num"),
    f("sv.startDelay", "Start delay", "num"),
    f("sv.endDelay", "End delay", "num"),
    f("sv.endOfRoundDelay", "End-of-round delay", "num"),
    f("sv.numPlayersNeededToStart", "Players needed to start", "num"),
    f("sv.notEnoughPlayersRestartDelay", "Restart delay (too few)", "num"),
    f("sv.timeBeforeRestartMap", "Time before map restart", "num"),
  ] },
  { group: "Friendly Fire", fields: [
    f("sv.soldierFriendlyFire", "Soldier FF (0–100)", "num"),
    f("sv.vehicleFriendlyFire", "Vehicle FF (0–100)", "num"),
    f("sv.soldierSplashFriendlyFire", "Soldier splash FF", "num"),
    f("sv.vehicleSplashFriendlyFire", "Vehicle splash FF", "num"),
    f("sv.tkPunishEnabled", "TK punish enabled", "toggle"),
    f("sv.tkNumPunishToKick", "TKs until kick", "num"),
    f("sv.tkPunishByDefault", "TK punish by default", "toggle"),
  ] },
  { group: "Teams / Balance", fields: [
    f("sv.autoBalanceTeam", "Auto team balance", "toggle"),
    f("sv.teamRatioPercent", "Team ratio (%)", "num"),
    f("sv.allowTitanMovement", "Titan movement", "toggle"),
  ] },
  { group: "Voting", fields: [
    f("sv.votingEnabled", "Voting enabled", "toggle"),
    f("sv.voteTime", "Vote time", "num"),
    f("sv.minPlayersForVoting", "Min players for voting", "num"),
  ] },
  { group: "Ranked / Unlocks", fields: [
    f("sv.useGlobalRank", "Global rank", "toggle"),
    f("sv.useGlobalUnlocks", "Global unlocks", "toggle"),
    f("sv.minUnlockLevel", "Min unlock level", "num"),
    f("sv.maxUnlockLevel", "Max unlock level (-1 = all)", "num"),
    f("sv.maxRank", "Max rank (0 = off)", "num"),
  ] },
  { group: "VoIP", fields: [
    f("sv.voipEnabled", "VoIP enabled", "toggle"),
    f("sv.voipQuality", "VoIP quality", "num"),
  ] },
  { group: "Radio / Anti-Spam", fields: [
    f("sv.radioSpamInterval", "Radio spam interval", "num"),
    f("sv.radioMaxSpamFlagCount", "Max spam flags", "num"),
    f("sv.radioBlockedDurationTime", "Radio block duration", "num"),
  ] },
  { group: "Branding / URLs", fields: [
    f("sv.sponsorText", "Sponsor text", "text"),
    f("sv.sponsorLogoURL", "Sponsor logo URL", "text"),
    f("sv.communityLogoURL", "Community logo URL", "text"),
    f("sv.customMapURL", "Custom map URL", "text"),
  ] },
  { group: "Other", fields: [
    f("sv.botSkill", "Bot skill (0–1)", "num"),
    f("sv.autoRecord", "Auto record (demos)", "toggle"),
    f("sv.allowNATNegotiation", "NAT negotiation", "toggle"),
  ] },
];

export const SETTINGS_KEYS = SETTINGS.flatMap((g) => g.fields.map((x) => x.key));
export const SETTING_TYPE: Record<string, SettingType> = Object.fromEntries(
  SETTINGS.flatMap((g) => g.fields.map((x) => [x.key, x.type])),
);
